import Vue from 'vue'
import store from '../../config/store'

const Modal = {
  data: () => ({
    defaultOptions: {
      wrapperClass: '',
      wrapperStyle: '',
      childVue: '',
      dataModel: {},
      active: false,
      successMessage: ''
    }
  }),

  methods: {

    showModal (options = {}) {
      const defaultOptions = {
        wrapperClass: '',
        wrapperStyle: '',
        size: 'modal-lg',
        childVue: '',
        dataModel: {},
        active: false,
        successMessage: '',
        blockLeaveBackground: false
      }

      store.modal = defaultOptions

      if (options.wrapperClass) {
        store.modal.wrapperClass = options.wrapperClass
      }

      if (options.size) {
        store.modal.size = options.size
      }

      store.modal.childVue = options.childVue
      store.modal.dataModel = options.dataModel
      store.modal.active = true
    },

    closeModal () {
      Vue.prototype.$bus.$emit('close-modal')
    }
  }
}

export default Modal
